/* ==========================================================================
   orange-loaf.js — ALL Orange Loaf custom JS for the Dawn theme.
   Loaded by ONE include line at the end of <head> in layout/theme.liquid
   (dawn-update-checklist item #1 — a Dawn update WIPES that line; re-add it).
   ========================================================================== */

/* Size Guide glue (dawn-update-checklist item #5).
   Globo Color Swatch hides Dawn's native variant picker (inline display:none
   on <variant-selects>) and renders its own picker. The inline "Size Guide"
   link lives in the native Size legend (snippets/product-variant-picker.liquid),
   so when Globo is active this moves a copy of it next to Globo's own
   "Size: X" label. If Globo is ever removed, the native link simply shows
   where it is and this script does nothing. */
(function () {
  var template = null;

  function place() {
    var globoSizeLabel = document.querySelector(
      '.swatch--gl legend.name-option[data-name="Size"]'
    );
    if (!globoSizeLabel) return; // Globo not rendered (yet) — nothing to do
    if (globoSizeLabel.querySelector('.ol-size-guide-inline')) return; // already placed

    if (!template) {
      var native = document.querySelector('variant-selects .ol-size-guide-inline');
      if (!native) return;
      template = native.cloneNode(true);
    }
    /* Fresh clone each time — Globo re-renders its picker on variant change,
       destroying whatever was inside. modal-opener binds its click handler on
       element upgrade, so a clone works as soon as it's inserted. */
    globoSizeLabel.appendChild(template.cloneNode(true));
  }

  var observer = new MutationObserver(place);

  function init() {
    place();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------------------
   Announcement bar: emphasise the money.
   Horizon shipped the bar as
       Up To 35% Off Site Wide! | Free Ship Over&nbsp;<strong>$75.00</strong>
   and that <strong> renders visibly heavier than the surrounding 700 text.
   Dawn's announcement block setting is `"type": "text"` and the section prints
   it through `| escape`, so HTML typed into the field would show up literally.
   We therefore do it here instead of editing sections/announcement-bar.liquid
   (never edit a file the theme ships with - a Dawn update would wipe it).

   Wraps any currency amount ($75, $75.00) in <strong class="ol-bar-strong">.
   Weight lives in orange-loaf.css rule 23. Idempotent, and it also swaps the
   space before the amount for a non-breaking one so "Over $75.00" cannot wrap
   apart on a narrow phone - Horizon used &nbsp; there for the same reason.
   Added 2026-07-28 (Shan asked for the $75 highlight back).

   2026-08-25: the bar now says "Free Shipping on 3 Shirts", so there is no
   money in it and the money-only matcher emphasised NOTHING. A shirt count
   ("3 Shirts") is now matched as well, keeping the bar's emphasis on the
   number the shopper has to hit - and keeping it in step with the cart
   drawer, which chips its own count. Still generic: a copy change from 3 to 2
   shirts, or back to a dollar threshold, needs no code edit.
   2026-09-06: the count may now carry a trailing "+" ("3+ Shirts"). Without
   the \+? the matcher found NOTHING in that copy and the bar went flat -
   silently, because a bar with no <strong> still renders fine. The nbsp goes in
   BOTH gaps of "on 3 Shirts" so the count can never split from its noun.
--------------------------------------------------------------------------- */
(function () {
  var MONEY = /(\$\d[\d,]*(?:\.\d{2})?|\d+\+?\s+Shirts?)/g;

  function emphasise() {
    var nodes = document.querySelectorAll('.announcement-bar__message');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector('.ol-bar-strong')) continue;   /* already done */
      var span = el.querySelector('span') || el;
      if (!span.textContent || span.textContent.search(MONEY) === -1) continue;
      if (span.children.length) continue;                 /* don't touch markup we didn't write */
      span.innerHTML = span.textContent
        .replace(/\s+(?=\$\d)/g, ' ')
        .replace(/\s+(?=\d+\+?\s+Shirts?)/g, ' ')
        .replace(MONEY, function (m) {
          return '<strong class="ol-bar-strong">' + m.replace(/\s+/g, ' ') + '</strong>';
        });
    }
  }

  function start() {
    emphasise();
    /* The bar is a slideshow component; re-run if it swaps or re-renders. */
    var bar = document.querySelector('.utility-bar') || document.body;
    new MutationObserver(emphasise).observe(bar, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();



/* ---------------------------------------------------------------------------
   Size must be chosen ON PURPOSE — ported from BuildMyPOD v2 (Shan 2026-08-21).

   Three behaviours, all here:
     a) nothing is pre-selected in the Size row on page load,
     b) Add to Cart is blocked while no size is picked,
     c) a blocked click flips the button to "Please select a size" in dark red
        (colour + label styling = orange-loaf.css rule 46).

   ⚠️ It has to drive GLOBO's picker, not Dawn's. The Globo Color Swatch app
   embed sets `style="display:none"` on <variant-selects> and renders its own
   markup (.globo-swatch-product-detail > .swatch--gl[data-option-index]), so
   Dawn's radios are invisible and styling/clearing them does nothing on screen.
   Same reason the Size Guide glue at the top of this file exists.

   Un-CHECKING the radio is all the visual work needed: Globo's "selected" look
   is `input:checked + label`, no extra class on the <li>, so the pill reverts
   by itself. Globo's own internal state still holds the default size, which is
   what keeps colour switching working while nothing is chosen.

   FAILS OPEN by design: if the size group can't be found (Globo removed, a
   one-option product, script ran too early) the guard does nothing and Add to
   Cart behaves exactly as it did before. Never leave a live store unable to
   add to cart.

   Reversal: delete this block + rule 46. See dawn-update-checklist.md.
--------------------------------------------------------------------------- */
(function () {
  var SIZE_LEGEND = '.swatch--gl legend.name-option[data-name="Size"]';
  var CART_FORM = 'form[data-type="add-to-cart-form"]';

  var chosen = false;      /* true once the shopper picks a size themselves */
  var original = null;     /* the real button label, restored on unflag */

  function sizeGroup() {
    var legend = document.querySelector(SIZE_LEGEND);
    return legend ? legend.closest('.swatch--gl') : null;
  }

  /* Clear the pre-selected size. Runs on every Globo re-render until the
     shopper picks one, then stops so changing COLOUR keeps their size. */
  function clearSize() {
    if (chosen) return;
    var group = sizeGroup();
    if (!group) return;

    var inputs = group.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) inputs[i].checked = false;
    }

    /* Legend reads "Size: S" — drop the value so it's just "Size:".
       Only write when it differs, otherwise this feeds its own observer. */
    var value = group.querySelector('legend .name-variant');
    if (value && value.textContent !== ':') value.textContent = ':';
  }

  function flag(form) {
    var btn = form.querySelector('.product-form__submit');
    var span = btn && btn.querySelector('span');
    if (!span) return;
    if (original === null) original = span.textContent;
    span.textContent = 'Please select a size';
    btn.classList.add('ol-needs-size');
  }

  function unflag() {
    var btns = document.querySelectorAll('.product-form__submit.ol-needs-size');
    for (var i = 0; i < btns.length; i++) {
      var span = btns[i].querySelector('span');
      if (span && original !== null) span.textContent = original;
      btns[i].classList.remove('ol-needs-size');
    }
  }

  /* CAPTURE phase on document, so this runs before Dawn's product-form.js
     submit handler (bound on the <form> itself) and can cancel it outright. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(CART_FORM)) return;
    var group = sizeGroup();
    if (!group) return;                                        /* fail open */
    if (group.querySelector('input[type="radio"]:checked')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    flag(form);
  }, true);

  document.addEventListener('change', function (e) {
    var group = sizeGroup();
    if (!group || !group.contains(e.target)) return;
    chosen = true;
    unflag();
  }, true);

  function init() {
    clearSize();
    new MutationObserver(clearSize).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------------------
   Variant photo preload (registry: "SNIPPET - ol-head", job 1).
   A colour tap makes Dawn fetch the product section first and only THEN start
   downloading that colour's photo. This downloads the other colours' photos
   in the background so the tap finds the photo already in the browser cache.
   - Starts only after the main gallery photo has loaded, then waits for an
     idle moment. One photo at a time, fetchPriority low.
   - Copies the gallery image's own srcset + sizes, so the browser picks the
     exact file the gallery will ask for later (same width, same URL).
   - URL list: <script id="ol-variant-media"> from snippets/ol-head.liquid.
     Skips the photo on screen and duplicates (Liquid uniq + the seen map).
   - Skipped on Save-Data and 2g/3g connections (navigator.connection exists
     on Android/Chrome only; iOS Safari has no such API, so it always runs
     there), and with ?ol_preload=0 in the URL (kept for before/after tests).
   - Only creates detached Image objects. Never touches price, availability,
     variant, URL or cart logic. If anything is missing it does nothing.
   Remove: delete this block and the product-page half of snippets/ol-head.liquid.
   --------------------------------------------------------------------------- */
(function () {
  var data = document.getElementById('ol-variant-media');
  if (!data || /[?&]ol_preload=0/.test(location.search)) return;
  var conn = navigator.connection;
  if (conn && (conn.saveData || /2g|3g/.test(conn.effectiveType || ''))) return;
  var urls;
  try { urls = JSON.parse(data.textContent); } catch (e) { return; }
  if (!urls || urls.length < 2) return;

  var keep = (window.__olPreload = []); // holds the Image objects (and lets tests count them)

  function galleryImg() {
    return document.querySelector('media-gallery li.is-active img') ||
      document.querySelector('media-gallery img');
  }

  function run() {
    var img = galleryImg();
    var srcset = img && img.getAttribute('srcset');
    var sizes = img && img.getAttribute('sizes');
    if (!srcset) return;
    // image_url gives ".../x.jpg?v=123&width=1946"; the srcset repeats ".../x.jpg?v=123&width=N"
    var bases = urls.map(function (u) { return String(u).split('&width=')[0]; });
    var current = null;
    bases.forEach(function (b) { if (srcset.indexOf(b + '&width=') > -1) current = b; });
    if (!current) return; // gallery shows a photo we can't map: do nothing
    var seen = {};
    seen[current] = true;
    var queue = bases.slice();

    function next() {
      var b = queue.shift();
      while (b && seen[b]) b = queue.shift();
      if (!b) return;
      seen[b] = true;
      var pre = new Image();
      pre.fetchPriority = 'low';
      pre.decoding = 'async';
      pre.onload = pre.onerror = function () { setTimeout(next, 100); };
      if (sizes) pre.sizes = sizes;
      pre.srcset = srcset.split(current).join(b);
      keep.push(pre);
    }
    next();
  }

  function start() {
    var img = galleryImg();
    if (!img) return;
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 300); };
    var go = function () { idle(run, { timeout: 2000 }); };
    if (img.complete && img.naturalWidth) go();
    else img.addEventListener('load', go, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
